import {OpportunityModel} from "./model";

export const OpportunitySerializer = (body) => {
    const opportunityModel = OpportunityModel();

    const create = async body => await opportunityModel.create(body);
    // opportunityModel.create(body);

    return Object.freeze({
        create
    });
}